<template>
    <v-container>
        <v-row>
            <!--Carrossel-->
            <v-col
                    v-if="$vuetify.breakpoint.mdAndUp"
                    cols="12"
                    lg="8"
                    md="12"
                    sm="12"
                    xs="12"

            >
                <v-carousel cycle>
                    <v-carousel-item
                            :to="'/split-oak-coffee-roasters'"
                            src="../assets/img/Sug4.png"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                    ></v-carousel-item>
                    <v-carousel-item
                            :to="'/vitamin-c-dear-serum'"
                            src="../assets/img/b1.png"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                    ></v-carousel-item>
                    <v-carousel-item
                            :to="'/split-oak-coffee-roasters'"
                            src="../assets/img/Sug5.png"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                    ></v-carousel-item>
                    <!--<v-carousel-item-->
                            <!--:to="'/dearskin'"-->
                            <!--src="../assets/img/b2.png"-->
                            <!--reverse-transition="fade-transition"-->
                            <!--transition="fade-transition"-->
                    <!--&gt;</v-carousel-item>-->
                    <v-carousel-item
                            :to="'/hyalu-dear-serum-hyaluronic-acid-booster'"
                            src="../assets/img/b3.png"
                            reverse-transition="fade-transition"
                            transition="fade-transition"
                    ></v-carousel-item>
                </v-carousel>
            </v-col>
            <!--banners-->
            <v-col
                    cols="12"
                    lg="4"
                    md="12"
                    sm="12"
                    xs="12"

            >
                <v-card :raised="true" :to="'/dearskin'" color="grey darken-1" dark>
                    <v-card-title>
                        Dearskin
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="8">
                                <span v-if="lang == 'en' ">Dearskin's skincare products promotes reduction of fine lines, wrinkles and slowing the aging process leads into a firmer, beautiful and healthy skin!</span>
                                <span v-if="lang == 'pt' ">Os produtos para a pele da Dearskin promovem a redução de linhas finas, rugas e retardam o processo de envelhecimento, resultando em uma pele mais firme, bonita e saudável!</span>
                                <span v-if="lang == 'es' ">Los productos para el cuidado de la piel de Dearskin promueven la reducción de líneas finas, arrugas y ralentizan el proceso de envejecimiento, lo que lleva a una piel más firme, bella y saludable.</span>
                            </v-col>
                            <v-col cols="4">
                                <v-img
                                        src="../assets/img/dearskin.png"
                                        lazy-src="../assets/img/170x130.png"
                                        max-width="100%"

                                ></v-img>
                                <br><br>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <br>
                <v-card :raised="true" :to="'/split-oak-coffee-roasters'" color="grey darken-4" dark>
                    <v-card-title>
                        SPLIT OAK COFFEE ROASTERS
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="4">
                                <v-img
                                        src="../assets/img/coffe.png"
                                        lazy-src="../assets/img/230x130.png"
                                        max-width="100%"

                                ></v-img>
                                <br>
                            </v-col>
                            <v-col cols="8">
                                Treat yourself, family & friends with hand-delivered fresh roasted coffee monthly, weekly or as often as you'd like. Subscribers get free hand delivery! Call to subscribe today.
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <!-- free shipping -->
        <v-row>
            <v-col
                    cols="12"
                    md="4"
            >
                <v-card :outlined="true" min-height="163px">
                    <v-row style="padding: 20px">
                        <v-col cols="4">
                            <v-img
                                    src="../assets/img/free_shopping.png"
                                    lazy-src="https://picsum.photos/id/11/10/6"
                                    max-width="100px"
                                    max-height="100px"

                            ></v-img>
                        </v-col>
                        <v-col cols="8">
                            <div class="body-2 text-uppercase mb-2">Free Shipping</div>
                            <div class="body-1 font-weight-bold mb-3">Every Day, Every Item</div>
                            <div class="caption grey--text">*Only for deliveries to the USA</div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col
                    cols="12"
                    md="4"
            >
                <v-card :outlined="true" min-height="163px">
                    <v-row style="padding: 20px">
                        <v-col cols="4">
                            <v-img
                                    src="../assets/img/telemarketing.png"
                                    lazy-src="https://picsum.photos/id/11/10/6"
                                    max-width="100px"
                                    max-height="100px"

                            ></v-img>
                        </v-col>
                        <v-col cols="8">
                            <div class="body-2 text-uppercase mb-2">Dedicated Support</div>
                            <div class="body-1 font-weight-bold mb-3">Replies within 24hrs</div>
                            <div class="caption grey--text">*Monday to Friday</div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col
                    cols="12"
                    md="4"
            >
                <v-card :outlined="true" min-height="163px">
                    <v-row style="padding: 20px">
                        <v-col cols="4">
                            <v-img
                                    src="../assets/img/shopping.png"
                                    lazy-src="https://picsum.photos/id/11/10/6"
                                    max-width="100px"
                                    max-height="100px"

                            ></v-img>
                        </v-col>
                        <v-col cols="8">
                            <div class="body-2 text-uppercase mb-2">SECURE</div>
                            <div class="body-1 font-weight-bold mb-3">Payments through Paypal</div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <!--Featured Products-->
        <v-row>
            <v-col
                    cols="12"
            >
                <p class="font-weight-bold mb-6 text-center display-2" v-if="lang == 'en' ">Featured Products</p>
                <p class="font-weight-bold mb-6 text-center display-2" v-if="lang == 'es' ">Productos Destacados</p>
                <p class="font-weight-bold mb-6 text-center display-2" v-if="lang == 'pt' ">Produtos em Destaque</p>
                <hr>
            </v-col>
        </v-row>
        <!--vitrine-->
        <v-row>
            <v-col
                    cols="6"
                    lg="3"
                    md="3"
                    sm="6"
                    xs="6"
                    v-for="(product,index) in products"
                    :key="index"

            >
                <v-card
                        class="mx-auto"
                        :hover="true"
                        :to="'/'+product.url_en"
                        v-if="lang=='en'"
                >
                    <v-img
                            v-if="product.images && $vuetify.breakpoint.smAndUp"
                            class="white--text align-end"
                            height="400"
                            max-height="420"
                            min-height="170"
                            :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                        <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                        <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                        <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                    </v-img>
                    <v-img
                            v-if="product.images && $vuetify.breakpoint.xsOnly"
                            class="white--text align-end"
                            height="210"
                            max-height="420"
                            min-height="170"
                            :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                        <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                        <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                        <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                        <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                        <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                        <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                class="title"
                                color="green"
                                text
                        >
                            ${{ product.price | number_format_real }}
                        </v-btn>
                        <v-btn
                                color="orange"
                                icon
                                class="display-4"
                                x-large
                        >
                            <v-icon>mdi-cart</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-card
                        class="mx-auto"
                        :hover="true"
                        :to="'/es/'+product.url_en"
                        v-if="lang=='es'"
                >
                    <v-img
                            v-if="product.images"
                            class="white--text align-end"
                            height="400"
                            max-height="420"
                            min-height="170"
                            :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                        <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                        <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                        <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                        <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                        <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                        <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                class="title"
                                color="green"
                                text
                        >
                            ${{ product.price | number_format_real }}
                        </v-btn>
                        <v-btn
                                color="orange"
                                icon
                                class="display-4"
                                x-large
                        >
                            <v-icon>mdi-cart</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
                <v-card
                        class="mx-auto"
                        :hover="true"
                        :to="'/pt/'+product.url_en"
                        v-if="lang=='pt'"
                >
                    <v-img
                            v-if="product.images"
                            class="white--text align-end"
                            height="400"
                            max-height="420"
                            min-height="170"
                            :src="'https://cdn.ppsbrands.com/products/'+product.images[0].image"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                    >
                        <v-card-title  v-if="lang == 'en' ">{{ product.name_en }}</v-card-title>
                        <v-card-title  v-if="lang == 'es' ">{{ product.name_es }}</v-card-title>
                        <v-card-title  v-if="lang == 'pt' ">{{ product.name_pt }}</v-card-title>
                    </v-img>
                    <v-card-text class="text--primary d-none d-lg-flex" style="height: 125px">
                        <div v-if="lang == 'en' ">{{ product.description_en }}</div>
                        <div v-if="lang == 'es' ">{{ product.description_es }}</div>
                        <div v-if="lang == 'pt' ">{{ product.description_pt }}</div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                class="title"
                                color="green"
                                text
                        >
                            ${{ product.price | number_format_real }}
                        </v-btn>
                        <v-btn
                                color="orange"
                                icon
                                class="display-4"
                                x-large
                        >
                            <v-icon>mdi-cart</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        metaInfo () {
            return {
                title: 'PPS Brands',
                meta: [
                    {description: 'PPS Brands'},
                    {keywords: 'PPS Brands'}
                ]
            }
        },
        data () {
            return {
                lang: "en",
                products: [
                    {
                        name: ' ',
                        images:false
                    },
                    {
                        name: ' ',
                        images:false
                    },
                    {
                        name: ' ',
                        images:false
                    },
                    {
                        name: ' ',
                        images:false
                    },
                ],
            }
        },
        methods:{
            init() {
                var  page = window.location.pathname.split('/');
                if(page[1] == 'pt' || page[1] == 'es'){
                    this.lang = page[1];
                }else{
                    this.lang = 'en';
                }
            },
            loadPage(){
                this.$http.get("https://api.ppsbrands.com/store/home").then(response =>{
                    this.products = response.data.products;
                });
            },
        },
        mounted(){
            this.$emit('showCart');
            this.loadPage();
            var self = this;
            setInterval(function(){
                    self.init();
                }, 1000
            );
        },
        filters:{
            number_format_real(valor){
                return String(parseFloat(valor).toFixed(2));
            },
        }
    }
</script>
